import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UXProvider } from './components/UXContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UXProvider>
      <App />
    </UXProvider>
  </React.StrictMode>
);

